import { IonLabel } from "@ionic/react";
import { useTheme } from "react-jss";
import { RequestDetailProgressBarStyle } from "./progressBarStyle.jss";
import { useTranslation } from "react-i18next";
import { DefaultValues } from "../../../../constants/defaultValues";
import { IRequestDetails } from "../../../../models/requestDetails";
import ProgressBar from "../../../../components/progressBar/progresBar";
import { convertToLocal } from "../../../../utils/dateUtils";
import { DateFormats } from "../../../../constants/dateFormats";
import { useEffect, useMemo, useState } from "react";
import { RequestStates } from "../../../../constants/requestStates";
interface IProgressBarTuck {
    request: IRequestDetails;
    visible: boolean;
}

export const RequestDetailProgressBar: React.FC<IProgressBarTuck> = ({ request, visible }) => {
    const theme = useTheme();
    const style = RequestDetailProgressBarStyle({ theme });
    const [progress, setProgress] = useState<number>(0);

    const { t } = useTranslation("common");

    useEffect(() => {
        let timerId: NodeJS.Timeout;
        if (visible) {
            timerId = setTimeout(() => setProgress(currentProgess), 1000); // Set the delay time as per your need.
        }
        return () => clearTimeout(timerId);
    }, [visible]);

    const currentProgess = useMemo(() => {
        switch (request.stateSort) {
            case RequestStates.DOCK:
                return 53;
            case RequestStates.EXIT:
                return 100;
            case RequestStates.DOCK_END:
                return 100;
            default:
                return 0;
        }
    }, [request]);

    const formatDateAndTime = (date: string | undefined, format: DateFormats) =>
        date ? convertToLocal(date, format) : format === DateFormats.DATE ? DefaultValues.DEFAULT_DATE : DefaultValues.DEFAULT_TIME;

    return (
        <div className={style.progressRequest}>
            <IonLabel className={style.label}>{t("PAGE.DETAILS_REQUEST.REQUEST_STATE")}</IonLabel>
            <ProgressBar percent={progress}></ProgressBar>

            <div className={style.progresRequestData}>
                <div className={style.progresRequestDataSection}>
                    <strong>{request.transportUnitNumber}</strong>
                    <span>{formatDateAndTime(request.carrierRegisterOn, DateFormats.DATE)}</span>
                    <span>{formatDateAndTime(request.carrierRegisterOn, DateFormats.HOUR_MINUTE)}</span>
                </div>
                <div className={style.progresRequestDataSection}>
                    <strong>{t("PAGE.DETAILS_REQUEST.DOCK_STATE")}</strong>
                    <span>{formatDateAndTime(request.dockStartOn, DateFormats.DATE)}</span>
                    <span>{formatDateAndTime(request.dockStartOn, DateFormats.HOUR_MINUTE)}</span>
                </div>
                <div className={style.progresRequestDataSection}>
                    <strong>{t("PAGE.DETAILS_REQUEST.EXIT")}</strong>
                    <span>{formatDateAndTime(request.dockEndOn, DateFormats.DATE)}</span>
                    <span>{formatDateAndTime(request.dockEndOn, DateFormats.HOUR_MINUTE)}</span>
                </div>
            </div>
        </div>
    );
};
